// const listeners={};

// export default{
//     $on(eventName,handler){
//         if(!listeners[eventName]){
//             listeners[eventName]= new Set();
//         }
//         listeners[eventName].add(handler);
//     },
//     $off(eventName,handler){
//         if(!listeners[eventName]){
//             return
//         }
//         listeners[eventName].delete(handler)
//     },
//     $emit(eventName,...args){
//         if(!listeners[eventName]){
//             return;
//         }
//         for(const handler of listeners[eventName]){
//             handler(...args);
//         }
//     }
// }

import Vue from "vue";
const app=new Vue({});
// mainScroll滚动条位置变化触发
// setMainScorll设置主区域滚动条位置时触发

Vue.prototype.$bus = app;
export default app;